import { AxiosInstance } from 'axios'

export interface GetModalsBlockArgs {
  locale: string
}

export interface ModalBlockDto {
  contact_us_title: string
  send_button_text: string
  book_now_button_text: string
  contact_me_title: string
  contact_me_text: string
  form_name_placeholder: string
  form_phone_placeholder: string
  form_email_placeholder: string
  form_experiance_placeholder: string
  form_message_placeholder: string | null
  apply_now_button_text: string
  contact_me_wrong_response: string
  contact_me_success_response: string
  vacancy_wrong_response: string
  vacancy_success_response: string
  createdAt: string
  updatedAt: string
  locale: string
}

export const getModalsBlock = async (client: AxiosInstance, { locale }: GetModalsBlockArgs) => {
  const path = '/modals-block'
  const params = {
    locale: locale,
    sort: { createdAt: 'desc' },
    populate: {
      '*': {
        fields: ['*'],
      },
      localizations: false,
    },
  }
  return (await client.get<{ data: { attributes: ModalBlockDto } }>(path, { params })).data.data.attributes
}
